export const desktopMaxWidth = 1330
export const desktopWithoutMargins = 1224
export const smallLaptopMaxWidth = 1200
export const bigTabletMaxWidth = 1080
export const tabletMaxWidth = 923
export const phoneMaxWidth = 577

export const maxWidthMediaQuery = (maxWidth: number) => `@media (max-width: ${maxWidth}px)`

export const minWidthMediaQuery = (minWidth: number) => `@media (min-width: ${minWidth}px)`

export const media = {
  desktopWithGuttersDown: maxWidthMediaQuery(desktopMaxWidth + 48),
  desktopWithoutMarginsUp: minWidthMediaQuery(desktopWithoutMargins),
  desktopBoundsDown: maxWidthMediaQuery(desktopMaxWidth),
  desktopBoundsUp: minWidthMediaQuery(desktopMaxWidth),
  smallLaptopDown: maxWidthMediaQuery(smallLaptopMaxWidth - 1),
  smallLaptopUp: minWidthMediaQuery(smallLaptopMaxWidth),
  bigTabletDown: maxWidthMediaQuery(bigTabletMaxWidth - 1),
  bigTabletUp: minWidthMediaQuery(bigTabletMaxWidth),
  tabletDown: maxWidthMediaQuery(tabletMaxWidth - 1),
  tabletUp: minWidthMediaQuery(tabletMaxWidth),
  phoneDown: maxWidthMediaQuery(phoneMaxWidth - 1),
  phoneUp: minWidthMediaQuery(phoneMaxWidth),
  smallPhoneDown: maxWidthMediaQuery(400),
  tinyPhoneDown: maxWidthMediaQuery(360)
}
